import Vue from 'vue'
import Vuex from 'vuex'
import columns from './modules/columns'
import presets from './modules/presets'
import deals from './modules/deals'
import users from './modules/users'
import settings from './modules/settings'
import deallist from './modules/deallist'

Vue.use(Vuex);
Vue.config.devtools = true;

export default new Vuex.Store({
    modules: {
        columns,
        deals,
        presets,
        users,
        settings,
        deallist
    }
})